<template>
  <span v-if="wines.length === 0" class="text-base text-3xl">Aktuell sind keine Weine vorhanden!</span>
  <Table
    v-else
    :headers="[
      { value: 'month', text: 'Monat' },
      { value: 'wine', text: 'Wein' },
      { value: 'type', text: 'Weinart' },
      { value: 'country', text: 'Herkunft' },
      { value: 'size', text: 'Fl-inhalt' },
      { value: 'price', text: 'Preis' },
    ]"
    :data="wines"
  >
    <template v-slot:row="props">
      <tr :class="[props.trClass, props.rowIndex % 2 === 0 ? 'bg-gray-100' : '']">
        <td :class="props.tdClass">
          {{ toLocaleLong(props.row.beginCampaign) }}
        </td>
        <td :class="props.tdClass">
          <nuxt-link :to="`${dir}/${props.row.slug}/`" class="hover:underline hover:text-gray-900 text-gray-700">{{
            wineLinkText(props.row)
          }}</nuxt-link>
        </td>
        <td :class="props.tdClass">
          {{ wineType(props.row) }}
        </td>
        <td :class="props.tdClass">
          {{ wineCountry(props.row) }}
        </td>
        <td :class="props.tdClass">
          {{ wineSize(props.row) }}
        </td>
        <template v-if="props.row.discount">
          <td
            v-if="
              props.row.discount &&
                year(props.row.beginCampaign) === currentYear &&
                month(props.row.beginCampaign) === currentMonth
            "
            :class="props.tdClass"
          >
            <span class="line-through">{{ props.row.price }} {{ props.row.currency }}</span>
            <span>{{ props.row.discount }} {{ props.row.currency }}</span>
          </td>
          <td v-else :class="props.tdClass">{{ props.row.price }} {{ props.row.currency }}</td>
        </template>
        <template v-if="props.row.prices">
          <td :class="props.tdClass">
            <span>verschiedene</span>
          </td>
        </template>
      </tr>
    </template>
  </Table>
</template>

<script>
import { mapGetters } from 'vuex'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'

import Table from '@/components/table/Table'

const DE = { locale: de }
const itemTypeMap = {
  r: 'R',
  rs: 'RS',
  s: 'S',
  w: 'W',
}

export default {
  components: { Table },
  props: {
    type: {
      type: String,
      default: 'wine-of-month',
    },
  },
  computed: {
    ...mapGetters({
      getWineOfMonthCampaigns: 'campaign/getWineOfMonthCampaigns',
    }),
    currentYear() {
      return new Date().getFullYear()
    },
    currentMonth() {
      return new Date().toLocaleString('de-de', { month: 'long' })
    },
    dir() {
      return `/l/${this.type === 'wine-of-month' ? 'wein-des-monats' : 'neue-weine'}`
    },
    wines() {
      return this.getWineOfMonthCampaigns(this.type)
    },
  },
  methods: {
    wineLinkText(row) {
      if (row.wine) {
        return `${row.wine.name}${row.wine.vintage ? ' ' + row.wine.vintage : ''}, ${row.wine.winegrower}`
      }
      if (row.wines) {
        if (row.wines[0].winegrower) return `${row.wines[0].winegrower}`
        else return `Weine des Monats - ${this.currentMonth}`
      }
    },
    wineType(row) {
      if (row.wine) {
        return row.wine.type.toUpperCase()
      }
      if (row.wines) {
        return ''
      }
    },
    wineCountry(row) {
      if (row.wine) {
        return row.wine.country
      }
      if (row.wines) {
        return `${row.wines[0].country}`
      }
    },
    wineSize(row) {
      if (row.wine) {
        return row.wine.size
      }
      if (row.wines) {
        return ''
      }
    },
    toLocaleLong(isoDatetime) {
      return format(Date.parse(isoDatetime), 'MMMM yyyy', DE)
    },
    year(start) {
      return new Date(Date.parse(start)).getFullYear()
    },
    month(start) {
      const date = new Date(Date.parse(start))
      return date.toLocaleString('de-de', { month: 'long' })
    },
    thisYear() {
      return format(new Date(), 'YYYY', DE)
    },
    // toLocaleShort(isoDatetime) {
    //   return format(Date.parse(isoDatetime), 'yy-MM', DE)
    // },
    toItemTypeMap(type) {
      return itemTypeMap[type]
    },
  },
}
</script>
